module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (92).676bdff7.jpg";